import * as tslib_1 from "tslib";
import * as React from 'react';
import { Avatar, IconButton, FontIcon, Popover } from 'material-ui';
import { avatar, monogram } from 'src/models/User';
import Badge from '../../components/Badge';
import { TaskStatus } from 'src/models/TaskStatus';
import { grey500, grey100 } from 'material-ui/styles/colors';
var containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    padding: '.5rem'
};
var itemStyle = {
    display: 'flex',
    margin: '0 .25rem'
};
var textStyle = {
    alignSelf: 'center',
    marginLeft: '.25rem',
    marginBottom: '0.1rem'
};
var popoverIconStyle = {
    padding: '.1rem',
    backgroundColor: grey100,
    borderRadius: '3px'
};
var TaskRelativeItem = function (props) { return (React.createElement("div", { style: itemStyle },
    React.createElement("span", { title: props.item.userName },
        React.createElement(Avatar, { key: props.item.userId, src: avatar(props.item.userId) })),
    React.createElement("span", null,
        React.createElement(Badge, { color: TaskStatus.colorify(props.item.statusId), styleOverride: textStyle }, props.item.competency),
        React.createElement(Badge, { color: TaskStatus.colorify(props.item.statusId), styleOverride: textStyle }, monogram(props.item.userName))))); };
var TaskRelativesList = function (props) { return (React.createElement("div", { style: containerStyle }, props.relatives.map(function (i) { return React.createElement(TaskRelativeItem, { key: i.userId, item: i }); }))); };
var TaskRelativesPopover = /** @class */ (function (_super) {
    tslib_1.__extends(TaskRelativesPopover, _super);
    function TaskRelativesPopover(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.setState({ anchorElement: e.currentTarget }, function () {
                _this.setState(function (state) { return ({ isPopoverOpen: !state.isPopoverOpen }); });
            });
        };
        _this.handleRequestClose = function (_) {
            _this.setState({ isPopoverOpen: false });
        };
        _this.state = {
            isPopoverOpen: false,
            anchorElement: null
        };
        return _this;
    }
    TaskRelativesPopover.prototype.render = function () {
        var relatives = this.props.relatives;
        if (!relatives || relatives.length === 0) {
            return null;
        }
        return (React.createElement("div", { style: popoverIconStyle },
            React.createElement(IconButton, { onClick: this.handleClick },
                React.createElement(FontIcon, { color: grey500, className: "material-icons" }, "group")),
            React.createElement(Popover, { open: this.state.isPopoverOpen, anchorEl: this.state.anchorElement, onRequestClose: this.handleRequestClose, useLayerForClickAway: false },
                React.createElement(TaskRelativesList, { relatives: relatives }))));
    };
    return TaskRelativesPopover;
}(React.Component));
export default TaskRelativesPopover;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskRelatives.tsx
// module id = 779
// module chunks = 0